import { render } from "./App.vue?vue&type=template&id=3f21328a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3f21328a&lang=scss"

import exportComponent from "/home/runner/work/proship-public-order/proship-public-order/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__